import React from "react";

const CircleStep = ({
  circleClass = "w-10 h-10 ",
  stepIndex = 0,
  label,
  onClick,
  stepLength,
  activeStep,
}) => {
  let isActive = activeStep === stepIndex;
  let isLastIndex = stepIndex === stepLength - 1;

  return (
    <div className={`${!isLastIndex && "w-full"} flex items-center h-28 `}>
      <button
        type="button"
        onClick={onClick}
        className={`min-w-fit w-auto flex flex-col items-center mx-4 mlg:mx-5 relative`}
      >
        <span
          className={`${circleClass} ${
            isActive
              ? "bg-primary ring-2 ring-primary ring-offset-2 ring-offset-custom-gray-100"
              : stepIndex < activeStep
              ? "bg-primary"
              : "bg-custom-gray-400"
          } rounded-full flex outline-none justify-center items-center text-lg text-white `}
        >
          {stepIndex + 1}
        </span>
        <span
          className={`text-sm mlg:text-base mt-3 absolute -bottom-8 mlg:-bottom-11 min-w-max`}
        >
          {label}
        </span>
      </button>
      {!isLastIndex && (
        <div className="w-full h-1 border-b border-custom-gray-700 "></div>
      )}
    </div>
  );
};

export default CircleStep;
